module.exports = __webpack_public_path__ + "img/payroll06.03c2afb4.jpeg";